import React, { useEffect, useCallback, useState} from 'react';
import UnknownProgressBar from "components/progressbar/UnknownProgressBar.js"
import GuildsMenu from "components/guilds/GuildsMenu.js";
import {sleep} from 'utils/sleep.js';
import Tags from './Tags.js';
import SampleOption from "./SampleOption.js"
import {useDropFiles} from "components/hooks/useDropFiles.js";
import {connect} from 'react-redux';
import '../../Uploader.scss';

const Uploader = ({store}) => { 

    let [uploading, setUploading] = useState(false);
    let [tags, setTags] = useState([]);
    let [saved, setSaved] = useState([]);
    let {sounds} = useDropFiles();

    const save = useCallback(async () => {
        // add tags to all sounds
        setUploading(true);
        sounds.forEach(s => s.tags = [...s.tags, ...tags]);
        let _saved = [];
        for (let s of sounds) {
            await s.saveSample();
            await sleep(250);
            _saved.push(s);
            setSaved([..._saved]);
        }
        setUploading(false);
    }, [sounds, tags, setUploading]);

    return (
        <div className="uploader">
          {uploading ? <UnknownProgressBar text="Uploading sounds"/> : ''}
          <div className="top-bar">
            <div>
              <GuildsMenu store={store}/>
              <div
                onClick={save}
                className={sounds.length === 0 ? "save-btn disabled" :"save-btn"}>
                Save
              </div>
              <div className="drop-files-here">
                <span>
                  Drop File Here
                </span>
              </div>
            </div>
            <Tags setTags={setTags} tags={tags} placeholder="Type tags for all"/>
          </div>
          {sounds.map(
              (sample, i) => 
                  <SampleOption isSaved={saved.includes(sample)} key={i} store={store} id={i+1} sample={sample}/>)}
        </div>
    );
}

const mapStateToProps = (state, props) => {
  return {
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Uploader);
